import _ from 'underscore';
import React, { useMemo } from 'react';

import BroadcastCard from 'components/cards/BroadcastCard';
import Container from 'components/Container';
import MultirowSlideSection from 'components/MultirowSlideSection';
import Section from 'components/Section';
import SimpleGrid from 'components/SimpleGrid';
import SizeDependedBlock from 'components/SizeDependedBlock';

import EntitiesPropTypes from 'utils/propTypes/entities';

const Catalog = ({ broadcast }) => {
	const sectionTitle = 'Ближайшие трансляции';

	const markupBlocks = useMemo(
		() => ({
			cards: { 'data-catalog': 'card' },
			moreButton: { 'data-catalog': 'archive' }
		}),
		[]
	);

	const moreControl = useMemo(
		() => ({ title: 'Расписание', url: '/schedule' }),
		[]
	);

	return (
		<SizeDependedBlock>
			<MultirowSlideSection
				title={sectionTitle}
				items={broadcast}
				moreControl={moreControl}
				CardComponent={BroadcastCard}
				gridSize={2}
				direction="columns"
				markupBlocks={markupBlocks}
			/>
			<Section
				title={sectionTitle}
				moreControl={moreControl}
				markupBlocks={markupBlocks}
			>
				<Container>
					<SimpleGrid>
						{_(broadcast).map((block) => (
							<BroadcastCard key={block._id} data={block} />
						))}
					</SimpleGrid>
				</Container>
			</Section>
		</SizeDependedBlock>
	);
};

Catalog.propTypes = {
	broadcast: EntitiesPropTypes.broadcast
};

Catalog.defaultProps = {
	broadcast: []
};

export default Catalog;
